import { cn } from "@/libs/cn";

const gridCols = "md:grid-cols-[7fr_6fr_3fr_2.5fr_4fr_3fr]";
const gridGap = "md:gap-6";
export const gridLayout = cn("flex flex-col gap-2 md:grid md:items-center", gridCols, gridGap, "px-4 md:px-6 py-3 md:py-2");

export const SKELETON_COLUMNS = 6;
export const MIN_WIDTH_CLASS_NAME = "md:min-w-[1100px]";

const ManagerUsersTabListHeader = () => {
  const headerStyle = "text-sm text-ui-navy-dark font-semibold text-gray-500 truncate";

  return (
    <div className={cn("hidden md:grid md:items-center", gridCols, gridGap, "bg-white border-b border-gray-100 px-6 py-4")}>
      <span className={headerStyle}>Nome</span>
      <span className={headerStyle}>E-mail</span>
      <span className={headerStyle}>Perfil</span>
      <span className={headerStyle}>Status</span>
      <span className={headerStyle}>Último acesso</span>
      <span className={headerStyle}>Criado em</span>
    </div>
  );
};

export default ManagerUsersTabListHeader;
